import Api from '../../api/api'
import Socket from '../../api/socket'
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    channels: [],
    isLoading: false,
    loadingPromise: null
  },
  getters: {
    channelById: (state) => (stationId) => {
      return state.channels.find((channel) => channel.id == stationId)
    },
    channelBySlug: (state) => (slug) => {
      return state.channels.find((channel) => channel.slug === slug)
    },
    mainChannel: (state, getters, rootState) => {
      return state.channels.find(channel => channel.id === rootState.stations.stationId)
    }
  },
  actions: {
    async fetch({ state, commit, dispatch }) {
      // Don't fetch if already loading
      if (state.isLoading) {
        return state.loadingPromise
      }

      // Only load this once
      if (state.channels.length) {
        return
      }

      try {
        const loadingPromise = Api.get('/2.0/channels')
        commit('CHANNELS_LOAD_START', loadingPromise);
        const { data } = await loadingPromise;
        if (Array.isArray(data.data)) {
          const channels = data.data.reduce((acc, channel) => {
            if (channel.type === 'channel') {
              acc.push(channel);
            }
            return acc;
          }, []);
          commit('CHANNELS_FETCHED', channels);
          dispatch('subscribeNowOnAir');
        } else {
          commit('CHANNELS_LOAD_FAIL');
        }
      } catch (error) {
        console.log(error)
        throw (error)
      }
    },

    subscribeNowOnAir({ state, commit }) {
      for (const channel of state.channels) {
        Socket.subscribe('plays', 'play', (data, envelope) => {
          data.stationId = envelope.station
          commit('CHANNEL_PLAY', data)
        }, { backlog: 1, station: channel.id })
      }
    },
  },
  mutations: {
    CHANNELS_FETCHED(state, channels) {
      state.isLoading = false;
      state.channels = channels.map((channel) => {
        const { type, color, data: { id, name, logo, slug, streams, api_url, account_required } } = channel;
        const hasVideo = Array.isArray(streams.video) && streams.video.length > 0;

        return {
          type,
          color,
          id,
          name,
          slug,
          streams,
          image: logo.active_iphone_url,
          url: api_url,
          accountRequired: account_required,
          banner: logo.radioplayer_banner,
          img: logo.site_logo,
          backgroundImage: logo.site_background,
          backgroundColor: color.foreground,
          textColor: color.extra,
          hasVideo,
        }
      })
    },
    CHANNELS_LOAD_START(state, promise) {
      state.isLoading = true;
      state.loadingPromise = promise
    },
    CHANNELS_LOAD_FAIL(state) {
      state.isLoading = false;
      state.loadingPromise = null;
    },
    CHANNEL_PLAY(state, play) {
      const channel = state.channels.find((channel) => channel.id == play.stationId)
      Vue.set(channel, 'lastPlay', play)
    },
  }
}
